import { Filter, Product, ProductMenuItem, getProductsData } from "@/store/productSlice";
import React, { cache, useEffect, useState } from "react";
import useResize from '@/hooks/use_resize';
import { prepareCardsForBuilderProductsGrid } from '@/translator';
import Box from '@mui/material/Box';
import Link from 'next/link';
import {
    Breadcrumbs,
    Divider,
    Grid,
    Typography,
    IconButtonProps,
    Button
} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Slide } from "@/components/designs_slideshow";
import CardsCarouselComponent from "@/components/styles";
import cssStyles from './deals.module.scss';
import { usePathname } from "next/navigation";
import { BreadCrumbData } from "@/utils/nest_types";
import { prepareErrorMessage, prepareErrorProps } from "@/components/nesterror";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { getHeaderDataWithCache, getStaticBasics } from "@/utils/getStaticBasics";
import { Vendor, getCatagoryList } from "@/store/commonSlice";
import allbrandsLogo from "@/assets/images/allbrands.png";
import { GetStaticProps, GetStaticPropsContext } from "next";
import RoomSelectorLayerButton from "@/components/popups/RoomSelectoLayerButton";
import Campaign from "@/store/campaign";
import MainMenuItem from "@/components/products/main_menu_item";
import { getRoomTypeList } from "@/store/commonSlice";
import { useRouter } from "next/router";
import ProductCard from '../../components/cms_renderer/Product/index'
import { getUserInfo } from "../../utils/useUserInfo";
import { fetchFavorites } from '../../components/cms_renderer/Product/utils/favoriteUtils'

const Deals: React.FC = (props: any) => {
    console.log("---------------------Deals page--- rendering initiated...");
    const {
        env,
        roomTypes,
        productsByBrand,
        productTypes,
        categoriesData,
        brand,
        vendorsData,
    } = typeof props.message == "string" ? JSON.parse(props.message) : props.message;

    const brandPathEntry = brand && brand !== "nestingale" ? `/${brand}` : "";
    const pathname = usePathname();
    const [selectedCategory, setSelectedCategory] = useState('');
    const router=useRouter()
    useResize();
    const productCardHeight = "250px";

    let vendors: Vendor[] = vendorsData?.vendors || [];
    if (vendors && vendors.length > 0) {
        let nestingaleVendorData = vendors.find((vendor: Vendor) => vendor.vendorName === "nestingale");
        if (!nestingaleVendorData) {
            vendors.unshift({
                vendorId: '0',
                vendorName: "nestingale",
                vendorDisplayName: "All Brands",
                vendorLogo: allbrandsLogo.src,
            } as Vendor)
        }
    }
    let vendorData = vendors.filter((vendor: Vendor) => vendor.vendorName === brand)[0];
    let vendorHomePage = vendorData?.landingPage || `${brandPathEntry}/rooms`;

    const breadCrumbData: BreadCrumbData[] = [];
    breadCrumbData.push({
        label: 'Deals',
        url: '/deals'
    })
    if (brand && brand !== "nestingale") {
        breadCrumbData.push(
            {
                label: vendorData.vendorDisplayName || brand,
                url: brandPathEntry + '/deals/'
            }
        )
    } else {
        breadCrumbData.push(
            {
                label: "All Brands",
                url: '/deals'
            }
        )
    }
    //fav functionality
    type FavoritesRecord = Record<string, string[]>; // Keys are product codes, values are arrays of product IDs

    const [userInfo, setUserInfo] = useState<any>(null);
    const [favorites, setFavorites] = useState<FavoritesRecord>({});
    useEffect(() => {
        async function fetchUserData() {
            setUserInfo(await getUserInfo());
        }
        fetchUserData();
    }, []);

    useEffect(() => {
        async function fetchFavoritesData() {
            if (userInfo) {
                const favorites = await fetchFavorites(userInfo?.cId);
                setFavorites(
                    favorites.reduce(
                        (acc: any, id: any) => ({ ...acc, [id]: true }),
                        {} as FavoritesRecord
                    )
                );
            }
        }
        fetchFavoritesData();
    }, [userInfo]);

    const buildBrandFilterCarousels = () => {
        return (
            <div>
                {
                    vendors && vendors.length > 1 && (
                        <div className={cssStyles.sub_cat_section}>
                            <Divider />
                            <Typography variant="subtitle2" color="text.primary">Shop by brand<ArrowForwardIosIcon fontSize="large" /></Typography>
                            <div className={cssStyles.carousel_section}>
                                <CardsCarouselComponent {...{
                                    name: "ShopByFilter",
                                    cards: vendors.map((vendor: Vendor) => {
                                        return {
                                            id: vendor.vendorName,
                                            name: vendor.vendorName,
                                            image: vendor.vendorLogo,
                                            imageUrl: vendor.vendorLogo,
                                            displayName: vendor.vendorDisplayName,
                                            selected: vendor.vendorName === brand,
                                            link: '/deals' + (vendor.vendorName !== "nestingale" ? `/${vendor.vendorName}` : ''),
                                        } as Slide;
                                    }),
                                    imageFill: "contain",
                                    showLabel: false,
                                    minWidth: '160px',
                                    maxWidth: '160px',
                                    catPage: true,
                                    fullWidth: true
                                }} />
                            </div>
                        </div>)
                }
            </div>
        )
    }


    const buildFilterByCategoryMenuPanel = () => {

        let mainMenuFilter: ProductMenuItem = {
            name: "categoryBy",
            displayName: "Category",
            items: categoriesData?.map((category: any) => {
                return {
                    id: "", // Add the missing property 'id'
                    hexaCode: "", // Add the missing property 'hexaCode'
                    name: category.name,
                    displayName: category.displayName,
                    image: category.imageUrl,
                    callback:  (selectedCategory: string) => { 
                        console.log('Category filter clicked', selectedCategory);
                        setSelectedCategory(selectedCategory) 
                    },
                } as Filter;
            })
        }
        return (
            <Box component='div'> 
                <MainMenuItem key={"mainMenuFilter-categoryBy"} {...mainMenuFilter} />
            </Box>
        )
    }
    interface ExpandMoreProps extends IconButtonProps {
        expand: boolean;
    }

    const handleProductSelection = ( event: any, card?: any,cardIndex?: any) => {
        //event.stopPropagation();
        console.log('Selected cardIndex: ' + cardIndex + "cardId : " + JSON.stringify(card));
        window?.nestDataLayer?.push({ 
            "event": "project_started",
            "pageType": window.pageViewDataLayerObj.pageType,
            "pageName": window.pageViewDataLayerObj.pageName,
            "pagePath": window.pageViewDataLayerObj.pagePath,
            "productName": card?.name,
            "productID": card?.id,
        });
    }

    const showProgress = () => {
        return (
            <Box component='div' sx={{ display: "flex", width: "100%", height: "600px", alignItems: "center", justifyContent: "center" }}>
                <CircularProgress />
            </Box>
        )
    }

    function prepareBrandDealsSection(): React.ReactNode {
        let brandDeals: any = [];
        productsByBrand && Object.keys(productsByBrand).forEach((key, i) => {
            let brandProducts = productsByBrand[key];
            brandProducts = brandProducts.filter((product: Product) => !selectedCategory || product.productType === selectedCategory);
            let vendor = vendors.find((vendor: Vendor) => vendor.vendorName === key);
            if (!brandProducts || brandProducts.length === 0) return;
            let rightSideCount = brandProducts.length > 1 ? 2 : brandProducts.length > 0 ? 1 : 0;
            brandDeals.push(
                <>  {/* First row */}

                    <Grid container key={"1strow-products"} id={"1strow-products"} className={cssStyles.productsBody} spacing={3} mt={1}>
                        {
                            /* Left side deals banner */
                            <Grid item xs={12} lg={rightSideCount > 1 ? 6 : rightSideCount > 0 ? 9 : 12}>
                                {vendor?.dealsBanner ? <img src={vendor?.dealsBanner} alt="Vendor Promo" style={{ width: "100%", borderRadius: '10px' }} />
                                    : <Typography variant="h1" color="text.primary" style={{ textAlign: "center", paddingTop: "50px" }}>{vendor?.vendorDisplayName || key}</Typography>}
                            </Grid>}

                        {/* Right side vertrical grid */}
                        <Grid item xs={12} lg={rightSideCount > 1 ? 6 : rightSideCount > 0 ? 3 : 0}>
                            <Grid container height="100%" spacing={3} sx={{ paddingBottom: '20px' }}>
                                {brandProducts && brandProducts.length > 0 &&
                                    brandProducts.splice(0, 2).map((item: any) => {
                                        return (<Grid xs={12} md={6} key={item.name} item lg={rightSideCount > 1 ? 6 : 12}>
                                            <ProductCard
                                                card={item as any}
                                                favorites={favorites}
                                                setFavorites={setFavorites}
                                                customerId={userInfo?.cId}
                                                onClick={(e, card) => handleProductSelection(e, card)}
                                                height={productCardHeight}
                                                pageName='deals-page'
                                            />
                                        </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Second row */brandProducts && brandProducts.length > 0 &&
                        <Grid key={"2ndrow-products"} container spacing={3} className="productsContainer" sx={{ marginTop: '0px' }}>
                            {brandProducts && brandProducts.length > 0 &&
                                (brand == 'nestingale' ? brandProducts.splice(0, 4) : brandProducts).map((item: any) => {
                                    return (<Grid key={item.name} item xs={12} md={3}>
                                        <ProductCard
                                            card={item as any}
                                            favorites={favorites}
                                            setFavorites={setFavorites}
                                            customerId={userInfo?.cId}
                                            onClick={(e, card) => handleProductSelection(e, card)}
                                            height={productCardHeight}
                                            pageName='deals-page'
                                        />
                                    </Grid>
                                    )
                                })
                            }
                        </Grid>}

                    {
                        /* View more link */
                        brandProducts && brandProducts.length > 0 && brand == 'nestingale' &&
                        <>
                            <div >
                                <Link href={`/deals/${key}`} className='viewMoreLink'>
                                    <Box component="div" sx={{ padding: '5px 0px', backgroundColor: 'backgrounds.bg_4', width: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                        <Box component="span" sx={{ color: 'white', paddingRight: '5px' }}>See more deals from {vendor?.vendorDisplayName} </Box> <ArrowOutwardIcon sx={{ color: 'white', fontSize: 'large' }} />
                                    </Box>
                                </Link>
                            </div>
                        </>

                    }

                    {
                        brand != 'nestingale' &&

                        <Button component={Link} href={`/${vendorHomePage}`} color="secondary" sx={{ margin: '50px auto', textTransform: 'capitalize', width: '300px', whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center' }}>Explore all {brand} Products</Button>

                    }

                    <Divider sx={{ margin: "20px" }} />

                    {(i === 0 || i === (Object.keys(productsByBrand).length - 1)) &&
                        (<Box component="div" className="container-fluid" sx={{ bgcolor: 'backgrounds.bg_2', padding: "0" }}>
                            <div className="container-spacing">
                                <div className={cssStyles["flex-two-column"]}>
                                    <div className={cssStyles["left-section"]}>
                                        <Box component="h3" className={cssStyles["heading-3"]} sx={{ fontFamily: 'Lora' }}>Need help discovering your personal style?</Box>
                                        <p>We got you. Take our 2 minute style quiz to discover your personal style.</p>
                                        <div className="row-gutter-2"></div>
                                        <Button color="secondary" className={"home-btn"} href="/stylequiz">Discover your unique style</Button>
                                    </div>
                                    <div className={cssStyles["right-section"]}>
                                        <Box component="h3" className={cssStyles["heading-3"]} sx={{ fontFamily: 'Lora' }}>Have a room in mind?</Box>
                                        <p>Start with a room and design your perfect space.</p>
                                        <div className="row-gutter-2"></div>
                                        {/* <RoomSelectorLayerButton color="secondary" openedFrom="dealspage_view_in_room" roomTypes={roomTypes}>Get your digital floorplan</RoomSelectorLayerButton> */}
                                        <Button color="secondary" onClick={()=>{router.push('/roomselection')}}>Select a room</Button>

                                        {/*<AppleDownloadPopupLayerButton color="secondary">
                                <span>Get your digital floorplan</span>s
                        </AppleDownloadPopupLayerButton>*/}
                                    </div>
                                </div>
                            </div>
                        </Box>)
                    }




                </>
            );
        }
        );
        return brandDeals;
    }

    return (<>
        <Campaign campaignName="deals" pageName="deals" />
        <div className={cssStyles.bRoot} >
            <Grid item xs={12}>
                <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="large" />}>
                    {
                        breadCrumbData.map((data, index) => {
                            return (
                                data.url != '' ? (
                                    <Box component='div' key={'breadcrumb' + index}>
                                        <a href={data.url} className={cssStyles[`${(breadCrumbData.length - 1) === index ? 'last_brcumb' : ''}`]}>{data.label}</a>
                                    </Box>
                                ) : (
                                    <Typography color="text.primary" fontSize={'14px'}>{data.label}</Typography>
                                )
                            )
                        })
                    }
                </Breadcrumbs>
            </Grid>
            <Divider />
            {/* Global Header */}
            <Grid container id="brandSelection">
                <Grid item xs={12}> {buildBrandFilterCarousels()} </Grid>
            </Grid>
            <Divider className={cssStyles.header_divider} />
            {false && categoriesData && categoriesData.length > 0 && buildFilterByCategoryMenuPanel()}
            <Grid container id="brandDeals">
                <Grid item xs={12}> {(prepareBrandDealsSection())} </Grid>
            </Grid>

        </div>
    </>
    )
};

export const getStaticPaths = async () => {
    const env = process.env.NEXT_PUBLIC_APP_ENV === 'qa' ? 'qa' : 'prod';
    let paths: { params: { env?: string; vendor?: string }; }[] = [];
    return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async (context: GetStaticPropsContext) => {
    const start = Date.now(); // Record start time
    try {
        var { vendor, vendorName, env, vendorsApiData, pageCacheInSec, vendorDisplayName } = await getStaticBasics(context);
        const headerMenuJson = await getHeaderDataWithCache(env, pageCacheInSec);
        let vendorHasDeals = { vendors: vendorsApiData.vendors.filter((vendor: Vendor) => vendor.hasDeals === true) || [] };
        let productsData = await getProductsData({ filterBy: 'curatedDeals:true', brand: vendorName, env: env });
        productsData.products = productsData.products.filter((product: any) => !product.availability || product.availability === "Available");
        let productTypes: string[] = [];

        const shopCategoryData = await getCatagoryList({env: env });

        let productsByBrand: Record<string, Product[]> = {};
        if (productsData?.products && productsData?.products.length > 0) {
            productsData?.products.map((product: any) => {

                let vendorName = product.vendorName || 'nestingale';
                let vendorProducts: Product[] = productsByBrand[vendorName];
                if (!vendorProducts) {
                    vendorProducts = [];
                    productsByBrand[vendorName] = vendorProducts;
                }
                const brandPathEntry = product.vendorName && product.vendorName !== 'nestingale' ? `/${product.vendorName}` : "";
                let pdpUrl = brandPathEntry + `/product/${product.productId}?from=deals`;
                let roomTypeParam = product.roomType ? '&roomType=' + product.roomType : '';
                let productTypeParam = product.productType ? '&productType=' + product.productType : '';
                let viewInYourRoomLink = `/builder?productId=${product.productId}&showcase=true&auth=false${roomTypeParam}${productTypeParam}`;
                // push to productTypes if it does not contain the product type
                productTypes.indexOf(product.productTypeName) === -1 && productTypes.push(product.productTypeName); 
                vendorProducts.push({
                    name: product.productName,
                    id: product.productId,
                    productType: product.productTypeName,
                    productTypeDisplayName: product.productTypeDisplayName,
                    image: product.productImage,
                    model3dUrl: product.model3dUrl,
                    pdpUrl: pdpUrl,
                    viewMoreUrl: "",
                    price: product.price,
                    comparePrice: product.comparePrice,
                    viewInYourRoomLink: viewInYourRoomLink,
                    priceRange: product.priceRange,
                    otherColors: product.otherColors,
                    otherSizes: product.otherSizes,
                    otherFabrics: product.otherFabrics,
                    configurationDisplayName: product.configurationDisplayName,
                    configurationIcon: product.configurationIcon,
                    expiresOn: product.expiresOn ? `Ends : ${new Date(product.expiresOn).toLocaleDateString()}` : 'While supplies last',
                    isBestSeller: product.isBestSeller
                });
            });
        }

        let categoriesData: any[] = [];
        shopCategoryData.prodTypeList.map((catType: any) => {
            productTypes.indexOf(catType.name) !== -1 && categoriesData.push(catType);
        });
        const roomTypes = await getRoomTypeList({ env: 'prod' });

        const pagePropObj = {
            env: env,
            headerMenuJson: headerMenuJson,
            roomTypes: roomTypes,
            productsByBrand: productsByBrand,
            productTypes: productTypes,
            categoriesData: categoriesData,
            brand: vendorName,
            vendorsData: vendorHasDeals,
            canonicalUrl : "https://nestingale.com/deals",
            requestProcessingTime: {
                start,
                end: Date.now(),
                duration: Date.now() - start
            }
        }

        const pageProps = JSON.stringify(pagePropObj);

        console.log(`Deals page --- getStaticProps completed in ${Date.now() - start}ms`);
        // append brand display name at the end of the title if it is not nestingale
        let title = "Deals" + (vendorName && vendorName !== "nestingale" ? ` - ${vendorDisplayName}` : "");
        let description = `Find high quality Products deals by the top furniture manufacturer ${vendorDisplayName}. Get design inspiration and home decor ideas, and find the perfect items for your home.`
        return {
            props: {
                message: pageProps,
                title: title,
                description: description,
                dataLayer: {
                    pageType: "Deals Page",
                }
            },
            revalidate: pageCacheInSec
        }
    } catch (error) {
        return prepareErrorProps(error, context, "Deals");
    };
}

export default Deals;


